/**
 * Marketplace sharh/reyting kontraktlari — xaridor mahsulotga baho + matn yozadi.
 *
 * Reyting CatalogItem'ga (kanonik mahsulot) bog'lanadi — barcha sotuvchilar bir
 * reytingni baham ko'radi (Uzum/Yandex pattern). FAQAT tasdiqlangan xarid
 * (CONFIRMED/COMPLETED buyurtma) sharh qoldira oladi (soxta sharh YO'Q).
 * Bir xaridor — bir mahsulotga bitta sharh (qayta yuborsa yangilanadi).
 */
import { z } from 'zod';
import { uuidSchema } from './common.schema.js';
// ─── Sharh yaratish/yangilash (buyer yuboradi) ────────────────────
export const createReviewSchema = z.object({
    catalogItemId: uuidSchema,
    rating: z.number().int().min(1, 'Reyting 1 dan kam emas').max(5, 'Reyting 5 dan ko‘p emas'),
    text: z.string().trim().max(2000, 'Sharh 2000 belgidan oshmasin').optional(),
});
//# sourceMappingURL=marketplace-review.schema.js.map